<script>
import {FormContextKey} from 'vee-validate';

export default {
    name: "NestedFormOverwrite",
    provide() {
        return {
            [FormContextKey]: this.parentValidator
        }
    },
    props: {
        parentValidator: {
            required: true
        },
        nestedValidation: {
            required: true
        },
    }
}
</script>

<template>
    <div>
        <slot />
    </div>
</template>

<style scoped>

</style>
